export const common = {
  // Navigation
  home: 'Home',
  cars: 'Cars',
  agencies: 'Agencies',
  about: 'About',
  contact: 'Contact',
  signIn: 'Sign In',
  signUp: 'Sign Up',
  login: 'Sign In',
  signup: 'Sign Up',
  logout: 'Logout',
  myAccount: 'My Account',
  dashboard: 'Dashboard',
  dashboardNav: 'Dashboard',
  
  // Location search
  location: 'Location',
  pickupDate: 'Pickup Date',
  returnDate: 'Return Date',
  selectDates: 'Select Dates',
  day: 'day',
  time: 'Time',
  
  // Homepage content
  findBookRental: 'Find, Book, Rental',
  easySteps: 'easy Steps',
  getCarWherever: 'Get Car Wherever',
  howItWork: 'How It Works',
  rentWithSteps: 'Rent With 3 Easy Steps',
  whyChooseUs: 'Why Choose Us',
  bestExperienceRental: 'Best Experience Rental',
  popularRentalDeals: 'Popular Rental Deals',
  mostPopularCars: 'Most Popular Cars',
  rent: 'Rent',
  showAllVehicles: 'Show All Vehicles',
  testimonials: 'Testimonials',
  whatPeopleSay: 'What People Say',
  
  // Steps
  chooseLocation: 'Choose Location',
  chooseLocationDesc: 'Select your pickup location',
  pickupDateDesc: 'Choose your pickup date',
  bookYourCar: 'Book Your Car',
  bookYourCarDesc: 'Complete your booking',
  
  // Benefits
  bestPriceGuaranteed: 'Best Price Guaranteed',
  bestPriceGuaranteedDesc: 'We offer the best prices',
  experienceDriver: 'Experience Driver',
  experienceDriverDesc: 'Professional drivers',
  carDelivery24h: 'Car Delivery 24h',
  carDelivery24hDesc: '24/7 delivery service',
  technicalSupport247: 'Technical Support 24/7',
  technicalSupport247Desc: 'Round the clock support',
  
  // Common actions
  search: 'Search',
  filter: 'Filter',
  book: 'Book',
  cancel: 'Cancel',
  confirm: 'Confirm',
  save: 'Save',
  saving: 'Saving...',
  saveChanges: 'Save Changes',
  refresh: 'Refresh',
  edit: 'Edit',
  delete: 'Delete',
  loading: 'Loading...',
  unknownError: 'Unknown error',
  submit: 'Submit',
  close: 'Close',
  back: 'Back',
  next: 'Next',
  clear: 'Clear',
  change: 'Change',
  manageColumns: 'Manage Columns',
  selectColumnsToDisplay: 'Select which columns to display in the table',
  resetDefault: 'Reset to Default',
  previous: 'Previous',
  yes: 'Yes',
  no: 'No',
  ok: 'OK',
  optional: 'Optional',
  none: 'None',
  amount: 'Amount',
  noLocationsFound: 'No locations found',
  saved: 'Saved successfully',
  goBack: 'Go Back',
  error: 'An error occurred',
  user: 'User',
  
  // Status
  status: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  pending: 'Pending',
  confirmed: 'Confirmed',
  completed: 'Completed',
  cancelled: 'Cancelled',
  
  // Signup Section
  joinKiraCar: 'Join KiraCar',
  chooseYourPath: 'Choose your path and start your journey with the best car rental platform',
  becomeClient: 'Become Client',
  clientDescription: 'Rent cars easily and quickly. Access a wide range of vehicles available near you.',
  signupAsClient: 'Sign up as Client',
  becomeAgency: 'Become Agency',
  agencyDescription: 'Manage your vehicle fleet and grow your business. Join our network of partner agencies.',
  signupAsAgency: 'Sign up as Agency',
  
  // Time
  today: 'Today',
  yesterday: 'Yesterday',
  tomorrow: 'Tomorrow',
  thisMonth: 'This Month',
  last7Days: '7 Last Days',
  last30Days: '30 Last Days',
  allPeriod: 'All Periods',
  customPeriod: 'Custom Period',
  customPeriodEllipsis: 'Custom Period...',
  selectCustomPeriod: 'Select Custom Period',
  startDate: 'Start Date',
  endDate: 'End Date',
  pickDate: 'Pick a date',
  apply: 'Apply',
  minute: 'minute',
  minutes: 'minutes',
  hour: 'hour',
  hours: 'hours',
  days: 'days',
  week: 'week',
  weeks: 'weeks',
  month: 'month',
  months: 'months',
  year: 'year',
  years: 'years',
  
  // Common phrases
  noDataFound: 'No data found',
  tryAgain: 'Try again',
  somethingWentWrong: 'Something went wrong',
  pleaseWait: 'Please wait...',
  
  // Languages
  english: 'English',
  french: 'Français',
  arabic: 'العربية',
  
  // Common statuses
  available: 'Available',
  unavailable: 'Unavailable',
  
  // Common
  view: 'View',
  welcome: 'Welcome',
  retry: 'Retry',
  
  // Error and Alert Messages
  warning: 'Warning',
  info: 'Information',
  
  // Booking Alerts
  failedToCancelBooking: 'Failed to cancel booking. Please try again.',
  bookingCancelledSuccessfully: 'Booking cancelled successfully',
  bookingNotPending: 'Only pending bookings can be cancelled',
  open24_7: 'Open 24/7',
  available24_7: 'Available 24 hours a day, 7 days a week',
  reservedDates: 'Reserved Dates',
  favorites: {
    loginRequired: 'Login Required',
    loginRequiredMessage: 'You need to be logged in to add cars to your favorites. Please log in or create an account to save your favorite cars.',
    addedToFavorites: 'Added to favorites',
    removedFromFavorites: 'Removed from favorites',
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    pageTitle: 'My Favorite Cars',
    pageDescription: 'View your favorite cars and manage your preferences',
    pageSubtitle: 'Cars you\'ve saved to your favorites',
    errorTitle: 'Error Loading Favorites',
    emptyTitle: 'No Favorite Cars Yet',
    emptyDescription: 'Start exploring cars and add them to your favorites by clicking the heart icon.',
    browseCars: 'Browse Cars',
    count: '{{count}} favorite car(s)'
  },
  confirmDeletion: 'Confirm Deletion',
  deleteBookingConfirmation: 'Are you sure you want to permanently delete your booking for {{car}} at {{agency}}? This action cannot be undone.',
  failedToDeleteBooking: 'Failed to delete booking',
  pleaseSelectDates: 'Please select pickup and return dates',
  failedToCreateBooking: 'Failed to create booking. Please try again.',
  carNotFound: 'Car not found',
  backToCars: 'Back to Cars',
  
  // Location Management Alerts
  locationTableNotExists: 'The agency_locations table does not exist yet. Please run the SQL script provided in complete_location_system_setup.sql',
  databaseError: 'Database error: {{message}}. Code: {{code}}',
  errorSavingLocation: 'Error saving location. Check the console for more details.',
  errorSettingDefaultLocation: 'Error setting default location. Check the console for more details.',
  
  // Contract Alerts
  errorDownloadingContract: 'Error downloading contract',
  errorPrintingContract: 'Error printing contract',
  
  // Booking
  booking: {
    contactInfo: 'Contact Information',
    contactInfoDescription: 'Please provide your contact details to complete your booking',
    confirmBooking: 'Confirm Booking',
    processing: 'Processing...',
    bookingCreated: 'Booking Created!',
    agencyWillContactYou: 'The agency will contact you soon on WhatsApp',
    keepPhoneAvailable: 'Please keep your phone available',
    bookingDetails: 'Booking Details',
    bookingId: 'Booking ID',
    createAccountBenefit: '🎁 Create an account to track your bookings!',
    trackAllBookings: 'Track all your bookings in one place',
    viewHistory: 'View booking history and receipts',
    fasterNextTime: 'Book faster next time',
    manageProfile: 'Manage your profile and preferences',
    createAccountNow: 'Create Account Now',
    maybeLater: 'Maybe Later',
    createYourAccount: 'Create Your Account',
    accountPreFilled: 'Your contact info is already filled',
    skipForNow: 'Skip for now',
    goToDashboard: 'Go to Dashboard',
  },

  // Authentication
  auth: {
    fullName: 'Full Name',
    enterFullName: 'Enter your full name',
    phone: 'Phone',
    enterPhone: 'Enter your phone number',
    email: 'Email',
    enterEmail: 'Enter your email address',
    password: 'Password',
    enterPassword: 'Enter your password',
    passwordMinLength: 'Minimum 6 characters',
    passwordTooShort: 'Password must be at least 6 characters',
    invalidEmail: 'Invalid email format',
    createAccount: 'Create Account',
    creatingAccount: 'Creating account...',
    accountCreated: 'Account Created!',
    accountCreatedSuccess: 'Your account has been created successfully. You can now track your bookings and manage your profile.',
    login: 'Login',
    alreadyHaveAccount: 'Already have an account?',
  },
  
  // Customer Management
  failedToDeleteCustomer: 'Failed to delete customer: {{message}}',
  areYouSureYouWantToDeleteThisCustomer: 'Are you sure you want to delete this customer? This action cannot be undone.',
  
  // Vehicle Management
  failedToUploadImage: 'Failed to upload image: {{fileName}}\\nError: {{error}}',
  selectVehicle: 'Select Vehicle',
  searchVehicle: 'Search for a vehicle...',
  
  // Profile Settings
  profileSettings: 'Profile Settings',
  manageProfileInfo: 'Manage your profile information and preferences',
  profilePicture: 'Profile Picture',
  uploadProfilePicture: 'Upload a profile picture to personalize your account',
  personalInformation: 'Personal Information',
  personalInfoDescription: 'Update your personal details and contact information',
  updatePersonalDetails: 'Update your personal details and contact information',
  fullName: 'Full Name',
  fullNamePlaceholder: 'Enter your full name',
  emailAddress: 'Email Address',
  emailCannotBeChanged: 'Email cannot be changed',
  emailCannotChange: 'Email address cannot be changed for security reasons',
  phoneNumber: 'Phone Number',
  clientType: 'Client Type',
  individual: 'Individual',
  company: 'Company',
  identityInformation: 'Identity Information',
  identityCardNumber: 'Identity Card Number (CIN)',
  drivingPermitNumber: 'Driving Permit Number',
  companyInformation: 'Company Information',
  iceNumber: 'ICE Number',
  iceNumberPlaceholder: '15-digit business identifier',
  updateProfile: 'Update Profile',
  updating: 'Updating...',
  profileUpdatedSuccessfully: 'Profile updated successfully!',
  profilePictureUpdatedSuccessfully: 'Profile picture updated successfully!',
  failedToUpdateProfile: 'Failed to update profile',
  
  // Password Management
  security: 'Security',
  changePassword: 'Change Password',
  passwordHelp: 'Update your password to keep your account secure',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmPassword: 'Confirm Password',
  updatePassword: 'Update Password',
  passwordChanged: 'Password changed successfully!',
  passwordUpdateFailed: 'Failed to update password',
  currentPasswordRequired: 'Current password is required',
  newPasswordRequired: 'New password is required',
  confirmPasswordRequired: 'Please confirm your new password',
  passwordTooShort: 'Password must be at least 6 characters',
  passwordMismatch: 'Passwords do not match',
  incorrectCurrentPassword: 'Current password is incorrect',
  fillAllFields: 'Please fill in all fields',
  
  // Coming Soon
  somethingAmazing: 'Something Amazing',
  isComingSoon: 'is Coming Soon',
  workingHardToDeliver: "We're working hard to bring you the ultimate car rental experience.",
  stayTuned: 'Stay tuned for updates!',
  comingSoon: 'Coming Soon',
  
  // Location types and search
  locations: {
    addCustomLocation: 'Add Custom Location',
    locationName: 'Location name',
    searchResults: 'Search Results',
    popularLocations: 'Popular Locations',
    noResults: 'No locations found',
    addLocation: 'Add Location',
    types: {
      airport: 'Airport',
      trainStation: 'Train Station',
      port: 'Port',
      mall: 'Shopping Mall',
      businessDistrict: 'Business District',
      cityCenter: 'City Center',
      city: 'City',
      district: 'District',
      landmark: 'Landmark'
    }
  },
  
  // Search functionality
  searching: 'Searching...',
  seconds: 'Seconds',
  enterYourEmail: 'Enter your email',
  notifyMe: 'Notify Me',
  beFirstToKnow: 'Be the first to know when we launch!',
  thanksNotifyWhenLaunch: "Thanks! We'll notify you when we launch.",
  
  // Browser notifications
  browserNotifications: {
    enable: 'Enable Notifications',
    enabled: 'Notifications enabled',
    permissionRequest: 'Allow KiraCar to send you notifications for important updates and alerts.',
    permissionGranted: 'Notifications enabled successfully!',
    permissionDenied: 'Notifications disabled',
    testTitle: 'KiraCar Notifications Enabled',
    testMessage: 'You will now receive notifications for important updates!',
    testSuccess: 'Test notification sent successfully',
    testFailed: 'Failed to send test notification',
    test: 'Test Notification'
  },
  
  // Success messages
  success: 'Success',
  
  // Footer
  companyDescription: 'Your trusted partner for premium car rental services. We provide reliable, affordable, and convenient transportation solutions.',
  quickLinks: 'Quick Links',
  forAgencies: 'For Agencies',
  joinAsAgency: 'Join as Agency',
  agencyHelp: 'Agency Help',
  termsOfService: 'Terms of Service',
  privacyPolicy: 'Privacy Policy',
  allRightsReserved: 'All rights reserved',
  poweredByRichaDev: 'Powered by RichaDev',
  
  // Agency Details
  agencyDetails: 'Agency Details',
  agencyNotFound: 'Agency not found',
  browseAgencies: 'Browse Agencies',
  businessStats: 'Business Statistics',
  totalVehicles: 'Total Vehicles',
  totalCars: 'Total Cars',
  availableCars: 'Available Cars',
  totalBookings: 'Total Bookings',
  agencyLocations: 'Locations',
  recentVehicles: 'Recent Vehicles',
  availableVehicles: 'Available Vehicles',
  noVehiclesAvailable: 'No vehicles available',
  getDirections: 'Get Directions',
  reviews: 'reviews',
  discoverVehicles: 'Discover our wide range of vehicles and book your perfect rental today',
  daysLeft: 'days left',
  daysRemaining: 'days remaining',
  viewAll: 'View All',
  showInMap: 'Show in Map',
  mobileSearch: {
    trigger: 'Where to?',
    title: 'Find your perfect car',
    description: 'Select your location and dates to start.',
  },
  featuredCategories: 'Featured Categories',
  featuredCategoriesDesc: 'Know what you\'re looking for? Browse our extensive selection of cars',
  popularDestinations: 'Popular Destinations',
  popularDestinationsDesc: 'Discover our most requested destinations for your next rental',
  carsFrom: 'Cars from',
  contactInfo: 'Contact Information',
  operatingHours: 'Operating Hours',
  viewVehicles: 'View Vehicles',
  callNow: 'Call Now',
  sendEmail: 'Send Email',
  verified: 'Verified',
  memberSince: 'Member since',
  pickupLocations: 'Pickup Locations',
  main: 'Main',
  closed: 'Closed',
  
  // Days of the week
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',

  // Dashboard specific
  myBookings: 'My Bookings',
  all: 'All',
  bookings: 'bookings',
  searchBookings: 'Search bookings...',
  quickActions: 'Quick Actions',
  contactAgency: 'Contact Agency',
  downloadContract: 'Download Contract',
  noBookingsYet: 'No bookings yet',
  startExploring: 'Start exploring our cars to make your first booking',
  bookNewCar: 'Book New Car',
  support: 'Support',
  viewDetails: 'View Details',

  // Booking Details Modal
  bookingDetails: 'Booking Details',
  vehicleInformation: 'Vehicle Information',
  agencyInformation: 'Agency Information',
  bookingTimeline: 'Booking Timeline',
  bookingSummary: 'Booking Summary',
  bookingId: 'Booking ID',
  bookingDate: 'Booking Date',
  duration: 'Duration',
  dailyRate: 'Daily Rate',
  paymentStatus: 'Payment Status',
  paid: 'Paid',
  unpaid: 'Unpaid',
  pickup: 'Pickup',
  return: 'Return',
  needHelp: 'Need Help?',
  contactSupportMessage: 'If you have any questions about your booking, feel free to contact our support team.',
  downloadInvoice: 'Download Invoice',
  cancelBooking: 'Cancel Booking',
  confirmCancellation: 'Confirm Cancellation',
  cancelBookingConfirmation: 'Are you sure you want to cancel your booking for {{car}} at {{agency}}? This action cannot be undone.',
  keepBooking: 'Keep Booking',
  transmission: 'Transmission',
  fuelType: 'Fuel Type',
  seats: 'Seats',
  category: 'Category',
  
  // Driver Information
  driverInformation: 'Driver Information',
  driverName: 'Driver Name',
  driverType: 'Driver Type',
  identityCard: 'Identity Card',
  drivingPermit: 'Driving Permit',
  registeredCustomer: 'Registered Customer',
  agencyClient: 'Agency Client',
  notSpecified: 'Not Specified',
  email: 'Email',
  
  // Additional Actions
  deleting: 'Deleting...',
  errorDeletingLocation: 'Error deleting location',
}; 